<style lang="less">

.index__rule {
    color: #FDB141;
    padding: .8rem .3rem .5rem;
    font-size: .24rem;
    line-height: 1.8;
}
.index__rule a,
.index__rule a:visited {
    color: #FDB141;
}

</style>
<template>
    <div class="index__rule">
        <ul>
            <li>1. 晋级用户参赛时间：{{finalBegin|time2text}}—{{finalEnd|time2text}}；</li>
            <li>2. 猜20根K线的涨跌幅，需在{{finalEnd|time2text}}前完成，否则成绩作废；</li>
            <li>3. 与初赛赛制不同，不可重复参赛，仅取一次成绩；</li>
            <li>4. 于{{finalRes|time2text}}揭晓猜涨跌幅成绩；</li>
            <li>5. 于{{awardTime|time2text('M月D日')}}核实颁发奖金及实物奖励等，所有奖品可叠加使用;</li>
            <li>6. 最终成绩以精准猜涨跌幅成绩最高的前三名获得重磅大奖；</li>
            <li>7. 如遇参赛成绩并列，则完成时间最早者获胜；</li>
            <li>8. 请务必使用常用手机号登录参赛，以确保成绩生成时，客服人员电话核实发奖；</li>
            <li>9. 客服电话：</li>
            <li class="ta_center">新浪客服<a href="tel:01062675412">010-62675412</a> 王者财经客服<a href="tel:4006776878">400-677-6878</a></li>
        </ul>
    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    export default {
        name: "index-rule",
        computed: {
            ...mapGetters(['finalBegin', 'finalEnd', 'finalRes', 'awardTime'])
        }
    };

</script>
